import React from 'react';
import useAppLayout from 'state/hooks/use-app-layout';
import { Card, CardActionArea, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import type { CharacterRewards } from '@monorepo/shared/src/graph/schema-generated-types-student';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { getLetters } from '@monorepo/shared/src/util/text-util';

interface StickerProps extends CharacterRewards {
  onCardClick: (character: string) => void;
}

const Sticker: React.FC<StickerProps> = ({
  character: { character, id },
  studentRewards,
  onCardClick,
}) => {
  const { containerHeight, containerWidth } = useAppLayout();
  const stickerSize = Math.min(containerHeight / 5, containerWidth / 7, 132);
  const classes = styles({ stickerSize });
  const selectedSticker = studentRewards?.find((obj) => obj.selected);

  const renderSticker = (
    <CardActionArea onClick={() => onCardClick(character)}>
      <img className={classes.sticker} src={selectedSticker?.reward?.asset?.src} alt="" />
    </CardActionArea>
  );

  const renderCharacter = (
    <Typography className={classes.character}>{getLetters(character)}</Typography>
  );

  return (
    <Card className={classes.card} id={`${id}`}>
      {selectedSticker ? renderSticker : renderCharacter}
    </Card>
  );
};

const styles = makeStyles((theme) => ({
  card: {
    width: ({ stickerSize }: any) => theme.typography.pxToRem(stickerSize),
    height: ({ stickerSize }: any) => theme.typography.pxToRem(stickerSize),
    border: `3px solid ${theme.palette.grey[700]}`,
    display: 'flex',
    justifyContent: 'center',
  },
  character: {
    fontFamily: FONT_GSS_FUTURA_BOLD,
    fontSize: ({ stickerSize }: any) => theme.typography.pxToRem(stickerSize * 0.4),
    lineHeight: ({ stickerSize }: any) => theme.typography.pxToRem(stickerSize),
  },
  sticker: {
    width: '100%',
    height: '100%',
  },
}));

export default Sticker;
